import { render, staticRenderFns } from "./TabsV2.vue?vue&type=template&id=5d4c6cb0&"
import script from "./TabsV2.vue?vue&type=script&lang=js&"
export * from "./TabsV2.vue?vue&type=script&lang=js&"
import style0 from "./TabsV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports